export var IdCoopCategory;
(function (IdCoopCategory) {
    IdCoopCategory[IdCoopCategory["CoopSearch"] = 57] = "CoopSearch";
    IdCoopCategory[IdCoopCategory["CoopInfoView"] = 58] = "CoopInfoView";
    IdCoopCategory[IdCoopCategory["CoopHelp"] = 59] = "CoopHelp";
    IdCoopCategory[IdCoopCategory["CoopChat"] = 60] = "CoopChat";
    IdCoopCategory[IdCoopCategory["CoopProjects"] = 61] = "CoopProjects";
    IdCoopCategory[IdCoopCategory["CoopEdit"] = 64] = "CoopEdit";
    IdCoopCategory[IdCoopCategory["CoopFound"] = 65] = "CoopFound";
    IdCoopCategory[IdCoopCategory["CoopMessageBoard"] = 62] = "CoopMessageBoard";
})(IdCoopCategory || (IdCoopCategory = {}));



//////////////////
// WEBPACK FOOTER
// ./src/features/cooperative/IdCoopCategory.ts
// module id = 102
// module chunks = 3